// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeSlider-categoryBoxLink-uFLFU,
.HomeSlider-categoryBoxLink-uFLFU:hover,
.HomeSlider-categoryBoxLink-uFLFU:focus {
    color: var(--primary-foreground);
    text-decoration: none;
    display: block;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Home/HomeSlider/HomeSlider.css"],"names":[],"mappings":"AAAA;;;IAGI,gCAAgC;IAChC,qBAAqB;IACrB,cAAc;IACd,eAAe;AACnB","sourcesContent":[".categoryBoxLink,\n.categoryBoxLink:hover,\n.categoryBoxLink:focus {\n    color: var(--primary-foreground);\n    text-decoration: none;\n    display: block;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categoryBoxLink": `HomeSlider-categoryBoxLink-uFLFU`
};
module.exports = ___CSS_LOADER_EXPORT___;
